<template>
	<div class="flex gap-5 py-2 flex-row items-center odd:bg-white even:bg-sky-50 px-5 justify-between">
		<div class="flex items-center cursor-pointer gap-2">
			<div class="text-blue-400"><i class="fa-regular fa-user"></i></div>
			<div>
				<p class="font-medium" @click.prevent="router.get(route('contacts.get', { contact: contact.id }))">
					<span class="uppercase">{{ contact.last_name }}</span> {{ contact.first_name }}
					<span v-if="contact.targeted" class="rounded text-blue-500 p-1">
						<i class="fas fa-crosshairs"></i>
					</span>
				</p>
				<div v-if="!displayEditModal" @click.prevent="router.get(route('contacts.get', { contact: contact.id }))">
					<p v-if="contact?.pivot.status_id" class="text-sm text-gray-500">
						{{ page.props.str.statuses.find((element) => element.id == contact.pivot.status_id)?.name }}
					</p>
					<p v-if="contact?.pivot.service_id" class="text-sm text-gray-500">
						{{ page.props.str.statuses.find((element) => element.id == contact.pivot.service_id)?.name }}
					</p>
				</div>
				<div v-else class="flex gap-2">
					<form-select
						:items="page.props.str.statuses.filter((element) => element.type == 'skill')"
						prefix="Statut : "
						placeholder="Statut"
						@valueChange="form.status = $event"
						:value="form.status"
						class="lg:col-span-1 col-span-2">
						<template v-slot:icon>
							<i class="fas fa-fw fa-caret-down"></i>
						</template>
					</form-select>
					<form-select
						:items="page.props.str.statuses.filter((element) => element.type == 'service')"
						prefix="Services : "
						placeholder="Service"
						@valueChange="form.service = $event"
						:value="form.service"
						class="lg:col-span-1 col-span-2">
						<template v-slot:icon>
							<i class="fas fa-fw fa-caret-down"></i>
						</template>
					</form-select>
				</div>
			</div>
		</div>
		<div class="flex flex-row gap-5 items-center">
			<div @click="$emit('update', form), toggleEditModal()" class="text-slate-500 hover:text-slate-700 cursor-pointer">
				<i v-if="displayEditModal" class="fas fa-check"></i>
			</div>
			<div @click="toggleEditModal()" class="text-slate-500 hover:text-slate-700 cursor-pointer">
				<i v-if="!displayEditModal" class="fas fa-edit"></i>
				<i v-else class="fas fa-cancel"></i>
			</div>
			<div @click="$emit('delete', contact.id)" class="text-slate-500 hover:text-slate-700 cursor-pointer">
				<i class="fas fa-trash"></i>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref } from 'vue';
	import { usePage, router } from '@inertiajs/vue3';

	const page = usePage();

	const props = defineProps({
		contact: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['delete', 'update']);

	const displayEditModal = ref(false);

	const form = ref({
		status: props.contact.pivot?.status_id || null,
		service: props.contact.pivot?.service_id || null,
		target: props.contact.id,
		id: props.contact.pivot?.id || null,
	});

	const toggleEditModal = () => {
		displayEditModal.value = !displayEditModal.value;
	};
</script>
